import { render, staticRenderFns } from "./TheYouTubeStandAlone.vue?vue&type=template&id=205db678&"
import script from "./TheYouTubeStandAlone.vue?vue&type=script&lang=js&"
export * from "./TheYouTubeStandAlone.vue?vue&type=script&lang=js&"
import style0 from "./TheYouTubeStandAlone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports